module.exports = "/_next/static/images/a1db793a3f7c829f803a1321811185cf-moneyboxes-left-desktop.jpg.webp";